import { render, staticRenderFns } from "./nested-answer-display.vue?vue&type=template&id=d009cbce&scoped=true"
import script from "./nested-answer-display.vue?vue&type=script&lang=js"
export * from "./nested-answer-display.vue?vue&type=script&lang=js"
import style0 from "./nested-answer-display.vue?vue&type=style&index=0&id=d009cbce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d009cbce",
  null
  
)

export default component.exports